import { LoginFormErrorJSON } from '../models/login-form';

export const formLoginErrors: LoginFormErrorJSON = {
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
    password: [
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
